import { render, staticRenderFns } from "./MyProjectsList.vue?vue&type=template&id=7c1334b1&"
import script from "./MyProjectsList.vue?vue&type=script&lang=js&"
export * from "./MyProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1334b1')) {
      api.createRecord('7c1334b1', component.options)
    } else {
      api.reload('7c1334b1', component.options)
    }
    module.hot.accept("./MyProjectsList.vue?vue&type=template&id=7c1334b1&", function () {
      api.rerender('7c1334b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/MyProjectsList.vue"
export default component.exports